import React, { useState, useRef } from 'lib/react';
import {
  EVGrid, EVPaper, EVList, EVListItem, EVButton, EVKeyboardArrowDown, EVKeyboardArrowUp,
} from 'lib/components';
import PropTypes, { arrayOf, number, oneOfType } from 'prop-types';
import Popper from 'commonComponents/popper';
import MultiSelectFilterOptionsStyles from './MultiSelectFilterOptionsStyles';
import SelectedFiltersRenderValue from '../selectedFiltersRenderValue';

function MultiSelectFilterOptions(props) {
  const {
    filterId, optionsList, handleChange, selectedOptions, handleClear, filterName,
  } = props;
  const classes = MultiSelectFilterOptionsStyles();
  const selectRef = useRef(null);
  const [anchorEl, setAnchorEl] = useState(null);

  const handleMenuOpen = (event) => setAnchorEl((el) => (el ? null : event.currentTarget));

  const handleClose = () => setAnchorEl(null);

  return (
    <EVGrid
      className={classes.filterContainer}
      ref={selectRef}
    >
      <EVButton
        id={`${filterId}-button`}
        variant="outlined"
        onClick={handleMenuOpen}
        className={classes.productsFieldButton}
      >
        <SelectedFiltersRenderValue
          selectedOptions={selectedOptions}
          optionsList={optionsList}
          handleClear={handleClear}
          iconElement={anchorEl ? <EVKeyboardArrowUp /> : <EVKeyboardArrowDown />}
          filterName={filterName}
          filterId={filterId}
        />
      </EVButton>
      <Popper
        popperId={`${filterId}-popper`}
        style={{ zIndex: 500, left: 0, right: 0 }}
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        placement="bottom-start"
        onClickAway={handleClose}
        disablePortal
      >
        <EVPaper className={classes.filterOptionsPaper}>
          <EVList style={{ padding: '0px' }}>
            {optionsList.map((option) => (
              <EVListItem
                id={`${filterId}-list-item-${option.id}`}
                data-testid={`${filterId}-list-item-${option.id}`}
                button
                key={option.id}
                onClick={() => { handleChange(option.id); }}
              >
                {option.description}
              </EVListItem>
            ))}
          </EVList>
        </EVPaper>
      </Popper>
    </EVGrid>
  );
}

MultiSelectFilterOptions.propTypes = {
  handleChange: PropTypes.func.isRequired,
  optionsList: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  filterId: PropTypes.string.isRequired,
  selectedOptions: PropTypes.arrayOf(oneOfType([arrayOf(number), number])).isRequired,
  handleClear: PropTypes.func.isRequired,
  filterName: PropTypes.string.isRequired,
};

export default MultiSelectFilterOptions;
